export const config = {
  // Production
  BASE_URL: 'https://knocard.com',

  // Staging
  // BASE_URL: 'https://staging.knocard.com',

  // local
  // BASE_URL: 'http://localhost:8000',

  SECRET_KEY: 'G9vKx2LmTqZ',

  AUTH_KEY: 'authkey',
  BEARER_TOKEN: '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',

  AUTO_ASSISTANT_CONTACT_NUMBER: '216-400-5617',
};

/// API endpoints
export const ApiEndpoint = {
  REQUEST_DEMO: 'api/enterprise/request-demo',
};

export const AppColors = {
  liteRedColor: '#FFCCD1',
  redColor: '#FF4155',
  whiteColor: '#FFFFFF',
  backgroundColor: '#FAFAFA',
  primaryColor: '#007CB4',
  blackColor: '#303336',
  grayZeroColor: '#EEF1F7',
  grayOneColor: '#AEB2B7',
  grayTwoColor: '#93989F',
  grayThreeColor: '#6B727A', // '#60656C',
  litePrimaryColor: '#E5F2FF',
  strokeColor: '#E8ECF4',
  yellowColor: '#FEC703',
  orangeColor: '#F7922C',
  secondaryColor: '#00B0E5',
  greenColor: '#00DB7D',
  tableHeader: '#007cb41f',
  lightYellowColor: '#FFDE59',
  lightYellowColor2: '#E8F13A',
  purpleColor: '#a259ff',

  blueColor: '#009ee1',
  menuColor: '#7c7cfc',
  textBlackColor: '#333333',

  textGradient: 'linear-gradient(to right, #9D61FF, #38C7FF)',
  aiGradient: 'linear-gradient(to right, #38C7FF, #9D61FF)',
  aiGradientTransparent:
    'linear-gradient(to right, rgba(157, 97, 255, 0.12), rgba(56, 199, 255, 0.12))',
  aiGradientCrossTransparent:
    'linear-gradient(to bottom right, rgba(157, 97, 255, 0.12), rgba(56, 199, 255, 0.12))',
  aiGradientTransparent2:
    'linear-gradient(to right, rgba(56, 199, 255, 0.16), rgba(157, 97, 255, 0.16))',
  aiGradientTransparent3:
    'linear-gradient(to right, rgba(56, 199, 255, 0.80), rgba(157, 97, 255, 0.80))',
  aiGradientCross: 'linear-gradient(to bottom right, #9D61FF, #38C7FF)',

  whiteTransparent: 'rgba(255, 255, 255, 0.12)',
};
